import colors from "common/constants/colorsOld";
import { SVG_UNITS_PER_100TH_INCH } from "common/constants/pdfSettings";
import type { BaseAnnoProps, BaseStyleProps } from "./svgSettings";
import { baseAnnoDefault, baseStyleDefault } from "./svgSettings";

interface RectOnlyProps extends BaseAnnoProps {
  fillColor?: string;
  width?: number;
  height?: number;
  opacity?: number;
}

type RectProps = RectOnlyProps & Pick<BaseStyleProps, "fillDarkPrimary" | "strokeDarkPrimary" | "highlightStrokeWidth">;

export const rectDefault: Required<RectProps> = {
  ...baseStyleDefault,
  ...baseAnnoDefault,
  fillColor: colors.emerald,
  width: 100,
  height: 100,
  opacity: 1,
};

export function generateRect(userProps: RectProps): string {
  const props = { ...rectDefault, ...userProps };
  const scale = props.scale * SVG_UNITS_PER_100TH_INCH;

  return `
    <g transform="translate(${props.x} ,${props.y}) scale(${scale},${scale})">
      <rect
        x="0"
        y="0"
        width="${props.width}"
        height="${props.height}"
        stroke="${props.strokeDarkPrimary}"
        stroke-width="${props.highlightStrokeWidth}"
        fill="${props.fillColor}"
        opacity="${props.opacity}"
      />
    </g>`;
}
